import React from 'react';
import { Phone, Mail, Globe, MapPin } from 'lucide-react';
import { footerData } from '../../data/mock';
import { Button } from '../ui/button';

const Footer = ({ onOpenEnquiry }) => {
  const scrollToSection = (href) => {
    if (href === '#hero') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const element = document.querySelector(href);
      if (element) element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#004534] text-white" data-testid="footer">
      {/* CTA Section - Centered */}
      <div className="border-b border-white/10">
        <div className="container mx-auto px-4 lg:px-8 py-16 text-center max-w-6xl">
          <h2 className="text-4xl md:text-5xl font-black mb-5">
            Ready to Start?
          </h2>
          <p className="text-white/70 text-lg mb-8 max-w-md mx-auto">
            Join 1000+ acres of professionally managed farmland
          </p>
          <Button
            onClick={onOpenEnquiry}
            className="bg-[#c4e538] text-[#004534] hover:bg-[#d4f548] font-black rounded-full px-8 py-4 text-lg shadow-xl hover:scale-105 transition-all"
            data-testid="footer-cta"
          >
            Enquire Now
          </Button>
        </div>
      </div>

      {/* Main Footer - Centered */}
      <div className="container mx-auto px-4 lg:px-8 py-12 max-w-6xl">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="mb-5">
              <span className="text-3xl font-black">
                Apna<span className="text-[#c4e538]">Farm</span>
              </span>
            </div>
            <p className="text-white/60 text-base mb-2">{footerData.tagline}</p>
            <p className="text-white/40 text-sm mb-6">{footerData.companyLine}</p>
            
            <div className="space-y-2">
              <a href={`tel:+91${footerData.phone}`} className="flex items-center gap-2 text-white/70 hover:text-white text-base transition-colors" data-testid="footer-phone">
                <Phone className="w-4 h-4" /> +91 {footerData.phone}
              </a>
              <a href={`mailto:${footerData.email}`} className="flex items-center gap-2 text-white/70 hover:text-white text-base transition-colors" data-testid="footer-email">
                <Mail className="w-4 h-4" /> {footerData.email}
              </a>
              <a href={`https://${footerData.website}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-white/70 hover:text-white text-base transition-colors">
                <Globe className="w-4 h-4" /> {footerData.website}
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-white text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {[
                { href: '#hero', label: 'Home' },
                { href: '#why', label: 'Why Us' },
                { href: '#crops', label: 'Crops' },
                { href: '#how-it-works', label: 'How It Works' },
                { href: '#income', label: 'Opportunity' },
                { href: '#faq', label: 'FAQ' },
              ].map((link) => (
                <li key={link.href}>
                  <button onClick={() => scrollToSection(link.href)} className="text-white/60 hover:text-white text-base transition-colors">
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Address */}
          <div>
            <h4 className="font-bold text-white text-lg mb-4">Offices</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 text-white/40 flex-shrink-0 mt-1" />
                <div>
                  <p className="text-white/40 text-xs mb-1">Corporate</p>
                  <p className="text-white/60 text-sm">{footerData.corporateAddress}</p>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 text-white/40 flex-shrink-0 mt-1" />
                <div>
                  <p className="text-white/40 text-xs mb-1">Registered</p>
                  <p className="text-white/60 text-sm">{footerData.registeredAddress}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Disclaimer - Three Lines */}
      <div className="border-t border-white/10">
        <div className="container mx-auto px-4 lg:px-8 py-6 max-w-6xl">
          <div className="text-center space-y-1">
            <p className="text-white/50 text-sm">{footerData.disclaimerLine1}</p>
            <p className="text-white/50 text-sm">{footerData.disclaimerLine2}</p>
            <p className="text-white/40 text-sm mt-2">{footerData.disclaimerLine3}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
